// ----------------------------------------------------------------------------
// Содержит элементы, необходимые для работы функций авторизации
// ----------------------------------------------------------------------------


const authElements = {
    headerTTUsers: document.querySelectorAll('.header_tt_user'),
    headerTTUserNames: document.querySelectorAll('.header_tt_user_name'),
    headerTTAuthRegistrations: document.querySelectorAll('.header_tt_auth_registration'),
    ttUserNickInForms: document.querySelectorAll('.ttUser_nick_in_form'),
    authForm: document.getElementById('ttOtzyv_authForm'),
    authFormHiddens: document.querySelectorAll('.ttOtzyv_authFormHidden'),
    nickInput: document.getElementById('ttOtzyvComment_nick'),
    formAuthMail: document.getElementById('js-respond-form_auth_mail'),
    formAuthPass: document.getElementById('js-respond-form_auth_pass'),
    buttonNext: document.getElementById('js-respond-form__btn-next'),
    respondFormPasses: document.querySelectorAll('.js-respond-form_pass'),
    rememberFormPasses: document.querySelectorAll('.js-respond-remember_pass'),
    respondFormCodes: document.querySelectorAll('.js-respond-form_code'),
    modalWindowContent: document.getElementById('js-respond-form__modal-window-content'),
    modalWindow: document.getElementById('js-respond-form__modal-window'),
};


export default authElements;

